<template>
  <div v-redirect-if-no-permission:DRIVERS :key="switch1">
    <loading-component :value="loading" />

    <v-layout class="mb-3" align-center wrap>
      <!-- Owner item 3.1: Active / Inactive / Banned. Kept outside the
           DataTable, whose toolbar disappears on an empty page. -->
      <account-state-filter
        entity="captain"
        :value="accountState"
        :counts="stateCounts"
        :window-days="stateWindowDays"
        :counts-failed="stateCountsFailed"
        @input="setAccountState($event, ['tab'])"
      />
      <!-- QA: active car-owner filter (arrives from Car Owners page) -->
      <v-chip
        v-if="carOwnerId"
        close
        color="primary"
        text-color="white"
        @input="clearOwnerFilter"
      >
        {{ $t("captainsPage.owner") }}: {{ $route.query.car_owner_name || ('#' + carOwnerId) }}
      </v-chip>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="$router.push({ name: 'CreateCaptain' })">
        {{ $t("captainsPage.new") }}
      </v-btn>
    </v-layout>

    <DataTable ref="list" :url="api.ACTIONS.CAPTAINS" :initial-url-search-params="driversParams" :initial-search="listSearch" :enable-edit="false" :enable-add="false" :enable-delete="false"
      :formatter="formatters" :actions-extra-main="actionsExtraMain" perPage="25" :fields-hidden-main="[
        'updated_at',
        'deleted_at',
        'blacklisted_at',
        'blacklist_note',
        'profile_image', 
        'full_name',
        'notification_token',
        'birthday',
        'avg_rating',
        'email',
        'nationality_id',
        'license_number'
      ]" :fields-unsortable="['status', 'account_state']" :titles="titles" :title='$t("captainsPage.registeredDriversTitle")' />


  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import Search from "@/components/monaco/SearchAgent";
import ConfirmCaptainDialog from "@/components/monaco/input/ConfirmCaptainDialog";
import LoadingComponent from "@/components/LoadingComponent";
import InterviewCreator from "@/components/driver_acquisition/InterviewCreator";
import AccountStateFilter from "@/components/AccountStateFilter";
import accountStateFilterMixin from "@/mixins/accountStateFilterMixin";
import { accountStateLabelHtml } from "@/constants/accountState";

export default {
  name: "RegisteredDrivers",
 // title: "Registered Drivers",
  components: {
    InterviewCreator,
    LoadingComponent,
    DataTable,
    Search,
    ConfirmCaptainDialog,
    AccountStateFilter,
  },
  mixins: [accountStateFilterMixin],
  data() {
    return {
      capStatus: "",
      // timer: "",
      switch1: null,
      loading: false,
      confirm_dialog: {
        visible: false,
        captain_id: null,
      },


    };
  },

  computed: {
    formatters() {
      return {
        autonome_mode: (value) =>
          value
            ? this.$t("captainsPage.autonome")
            : this.$t("captainsPage.normalMode"),
        created_at(value) {
          return formatCompanyTime(value, "YYYY-MM-DD");
        },
        birthday(value) {
          return formatCompanyTime(value, "YYYY-MM-DD");
        },
        gender: (value) =>
          value == 1
            ? this.$t("captainsPage.male")
            : this.$t("captainsPage.female"),
        type: (value) =>
          value == "internal"
            ? this.$t("captainsPage.snapDriver")
            : this.$t("captainsPage.external"),
        account_code: (value) => (value === null || value === undefined || value === "" ? "-" : value),
        // Owner item 3.1: replaces the old tick/cross of blacklisted_at.
        account_state: (value) => accountStateLabelHtml(value, (key) => this.$t(key)),
        status: (val) => {
          if (val == "FREE")
            return this.$t("captainsPage.statusOnline");
          else if (val == "UNAVAILABLE")
            return this.$t("captainsPage.statusOffline");
          else if (val == "AT_DESTINATION")
            return this.$t("captainsPage.statusAtDestination");
          else if (val == "BUSY")
            return this.$t("captainsPage.statusBusy");
          else return val;
        },
      };
    },
    // QA: pre-filter by car owner when arriving from the Car Owners page.
    carOwnerId() {
      return this.$route.query.car_owner_id || null;
    },
    driversParams() {
      const params = new URLSearchParams();
      if (this.carOwnerId) params.append("car_owner_id", this.carOwnerId);
      if (this.accountState !== "all") params.append("account_state", this.accountState);
      return params;
    },
    // Read by accountStateFilterMixin: the chip counts follow the owner filter.
    stateCountsUrl() {
      return this.api.ACTIONS.CAPTAIN_STATE_COUNTS;
    },
    stateCountsParams() {
      return this.carOwnerId ? { car_owner_id: this.carOwnerId } : {};
    },
    titles() {
      return {
        created_at: this.$t("captainsPage.creationDate"),
        id: "#",
        email: this.$t("captainsPage.email"),
        active: this.$t("captainsPage.wasApproved"),
        first_name: this.$t("captainsPage.firstName"),
        last_name: this.$t("captainsPage.lastName"),
        // Live connection (online / offline / busy), not the account state.
        status: this.$t("captainsPage.connectionStatus"),
        username: this.$t("captainsPage.phone"),
        gender: this.$t("captainsPage.gender"),
        type: this.$t("captainsPage.type"),
        license_number: this.$t("captainsPage.licenseNumber"),
        address: this.$t("captainsPage.address"),
        nationality_id: this.$t("captainsPage.nationalityId"),
        account_state: this.$t("accountState.label"),
        avg_rating: this.$t("captainsPage.averageRating"),
        account_code: this.$t("captainsPage.accountCode")
      };
    },
    actionsExtraMain() {
      return {
        profile: {
          title: this.$t("captainsPage.captainProfile"),
          icon: "account_circle",
          action: (item) =>
            this.$router.push({
              name: "CaptainProfile",
              params: { id: item.id },
            }),
        },
      };
    },

  },

  methods: {
    clearOwnerFilter() {
      const query = { ...this.$route.query };
      delete query.car_owner_id;
      delete query.car_owner_name;
      this.$router.replace({ path: "/drivers", query });
    },

    actionsExtra(state) {


      const goToProfile = {
        title: this.$t("captainsPage.goToProfile"),
        icon: "info",
        extras: {
          color: "secondary",
          large: true,
        },
        action: async (item) =>
          this.$router.push({
            name: "CaptainProfile",
            params: item,
          }),
      };
      return { goToProfile }
    },
  },
};
</script>

<style scoped></style>
